import React, { useRef } from 'react'
import { useAppState } from '../../../redux/reducer/content'
import { CSSTransition, SwitchTransition } from 'react-transition-group'
import { appContent } from '../../../constants/content'
import Navigation from '../navigation/Navigation'
import Container from '../container/Container'
import { useElfLogic } from '../../../hooks/useElfLogic'
import { useOpenLink } from '../../../hooks/useOpenLink'
import { useBodyClassByState } from '../../../hooks/useBodyClassByState'
import { useApplicationCallbacks } from '../../../providers/application-callbacks'
import useHandleIsOnline from '../../../hooks/shared/availability/useHandleIsOnline'
import useThemeHandler from '../../../hooks/shared/theme/useThemeHandler'
import useModalsData from '../../../hooks/useModalsData'
import useCheckUserRegisterDate from '../../../hooks/shared/user/useCheckUserRegisterDate'
import useHandleCanvasLostError from '../../../hooks/shared/canvas/useHandleCanvasLostError'

const PageComponent = React.forwardRef(function (props, ref) {
  const state = useAppState()
  const containerRef = useRef()

  const { Component = 'div', props: componentProps = {} } = appContent[state] ?? {}

  const callbacks = useApplicationCallbacks()
  const { entered, exited, enter } = useElfLogic()

  useHandleIsOnline()
  useBodyClassByState()
  useOpenLink()
  useThemeHandler()
  useModalsData()
  useCheckUserRegisterDate()
  useHandleCanvasLostError()

  return (
    <div
      className={`page-component`}
      ref={ref}
    >
      <SwitchTransition component={null}>
        <CSSTransition
          key={state}
          nodeRef={containerRef}
          timeout={{ enter: 500, exit: 500 }}
          classNames={'container'}
          onEntered={() => entered(state)}
          onExited={() => exited(state)}
          onEnter={() => enter(state)}
        >
          <Container
            className={`container_${state}`}
            containerRef={containerRef}
          >
            <Component
              callbacks={callbacks}
              {...componentProps}
            />
          </Container>
        </CSSTransition>
      </SwitchTransition>
      <Navigation />
    </div>
  )
})
export default PageComponent
PageComponent.propTypes = {}
